(() => {
  const initWalltraudRegalLandingpage = () => {
    const heroButton = document.querySelector('.wt-regal-section [data-wt-hero-cta]');
    const products = document.getElementById('wt-regal-products');
    const sticky = document.querySelector('.wt-regal-section [data-wt-sticky]');

    if (sticky && sticky.dataset.wtInitialized !== 'true') {
      sticky.dataset.wtInitialized = 'true';

      if (heroButton && products && 'IntersectionObserver' in window) {
        let heroVisible = true;
        let productsVisible = false;

        const updateSticky = () => {
          const show = !heroVisible && !productsVisible;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        };

        const heroObserver = new IntersectionObserver((entries) => {
          heroVisible = entries[0].isIntersecting;
          updateSticky();
        }, { threshold: 0 });

        const productObserver = new IntersectionObserver((entries) => {
          productsVisible = entries[0].isIntersecting;
          updateSticky();
        }, { threshold: 0.08 });

        heroObserver.observe(heroButton);
        productObserver.observe(products);
      }
    }

    document.querySelectorAll('.wt-regal-section a[href^="#"]').forEach((link) => {
      if (link.dataset.wtSmoothScroll === 'true') return;
      link.dataset.wtSmoothScroll = 'true';

      link.addEventListener('click', (event) => {
        const selector = link.getAttribute('href');
        if (!selector || selector === '#') return;

        const target = document.querySelector(selector);
        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWalltraudRegalLandingpage);
  } else {
    initWalltraudRegalLandingpage();
  }

  document.addEventListener('shopify:section:load', initWalltraudRegalLandingpage);
})();
